import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getReport, ReportParameter } from "@tKgpco/Services/CustomPurchaseHistoryService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type ReportReqParam = {
    formData: ReportParameter;
};
type ReportParameterParam = HasOnSuccess & ReportReqParam & HasOnError;

type HandlerType = CustomApiHandler<ReportParameterParam, BlobPart>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    const {
        formData: { searchType, searchValue, fromDate, toDate, outputformat },
    } = props.apiParameter;
    const data = {
        searchType,
        searchValue,
        fromDate,
        toDate,
        outputformat,
    };
    try {
        props.apiResult = (await getReport(data)) as unknown as BlobPart;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
    //     const blob = new Blob([props.apiResult], { type: "application/pdf" });
    //     const url = window.URL.createObjectURL(blob);
    //     const link = document.createElement("a");
    //     link.href = url;
    //     if (props.parameter.formData.outputformat === "excel") {
    //         link.setAttribute("download", `${"myExcel"}}.xlsx`);
    //         link.download = `${"myExcel"}${Date.now()}.xlsx`;
    //         link.click();
    //     }
    // else  if (props.parameter.formData.outputformat === "pdf") {
    //     link.setAttribute("download", `${"myPDF"}}.pdf`);
    //     link.download = `${"myPDF"}${Date.now()}.pdf`;
    //     link.click();
    // } else {
    //         link.target = "_blank";
    //         link.click();
    //     }

        if (props.parameter?.onSuccess) {
            props.parameter.onSuccess();
        }
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const purchaseHistoryReportHandler = createHandlerChainRunner(chain, "getReport");
export default purchaseHistoryReportHandler;
